import { Col } from "@/common/css";
import { Container } from "@/common/ui/container";
import GoogleSignInButton from "@/common/ui/GoogleSignInButton";
import { LightText2 } from "@/common/ui/Text";
import FormRender from "@/components/Form/Renderer/RenderForm";
import { loginSelector } from "@/store/features/loginSlice";
import { GOOGLE_CLIENT_ID } from "@/utils/constant/globalEnv.constant";
import { atLeastOneUpperLowerNumberSpecialCharRegex } from "@/utils/helper/string";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import { useSelector } from "react-redux";

const CheckPasswordConfig = {
  submitBtnText: "Confirm",
  showLabel: false,
  sections: [
    {
      widgets: [
        {
          widgetType: "password",
          label: "Please enter your current password",
          field: "currentPassword",
          validation: {
            required: true,
            pattern: {
              value: atLeastOneUpperLowerNumberSpecialCharRegex,
              message: "Invalid password format",
            },
          },
        },
      ],
    },
  ],
};

interface VerifyItsYouAlertProps {
  onClose: (props?: any) => void;
  handleVerifyPassword: (data: any) => Promise<void>;
  handleReject: () => void;
  reqInfo: any;
  modalProps: {
    descriptions: string[];
    submitText?: string;
  };
}

const VerifyItsYouAlert: React.FC<VerifyItsYouAlertProps> = ({ onClose, handleVerifyPassword, reqInfo, handleReject, modalProps }) => {
  const authenticationType = reqInfo?.authenticationType?.split(",");
  const { currentUser } = useSelector(loginSelector);

  const { submitText, descriptions } = modalProps || {};
  if (submitText) {
    CheckPasswordConfig.submitBtnText = submitText;
  }

  const handleCancel = () => {
    handleReject();
    onClose();
  };

  return (
    <>
      <Container.Content className="pt-2 px-4">
        {descriptions?.length > 0 && (
          <Col className="gap-y-2">
            {descriptions.map((d, i) => (
              <LightText2 key={`description${i}`} text={d} className="" />
            ))}
          </Col>
        )}
      </Container.Content>
      {authenticationType?.includes("DIRECT") && (
        <FormRender
          handleFormSubmit={handleVerifyPassword}
          handleCancel={handleCancel}
          formConfig={CheckPasswordConfig}
          className="p-4"
          formClassName=""
          btnContainerClass="!pt-1"
          isAlert
        ></FormRender>
      )}
      {authenticationType?.includes("GOOGLE") && (
        <div className=" py-2 pb-5 px-4">
          {authenticationType?.length > 1 && (
            <div className="flex items-center mb-4">
              <div className="flex-grow border-t border-gray-300"></div>
              <span className="flex-shrink mx-6 text-gray-600">or</span>
              <div className="flex-grow border-t border-gray-300"></div>
            </div>
          )}
          {/* Google Sign-in */}
          <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <GoogleSignInButton
              handleSignIn={handleVerifyPassword}
              btnText="Authorize with Google"
              isLoading={false}
              hideOneTab
              prefillEmail={currentUser?.email}
            />
          </GoogleOAuthProvider>
        </div>
      )}
    </>
  );
};

export default VerifyItsYouAlert;
